<template>
    <el-dialog
      :title="dialogType == 'add' ? '添加规则' : '编辑规则'"
      :visible.sync="visible"
      :close-on-click-modal="false"
      @closed="closeRuluer"
      width="680px"
    >
      <el-form ref="rulurform" :model="formData" :rules="rules" label-width="170px" label-position="left">
        <el-form-item label="最高门店显示价区间：" required>
          <div style="display:flex">
            <el-form-item label-width="0" prop="priceMin">
              <el-input v-model="formData.priceMin" placeholder="请输入起始值" @input="inputNumber($event, formData, 'priceMin')" />
            </el-form-item>
            <div style="margin:0 10px">~</div>
            <el-form-item label-width="0" prop="priceMax">
              <el-input v-model="formData.priceMax" placeholder="请输入结束值" @input="inputNumber($event, formData, 'priceMax')" />
            </el-form-item>
          </div>
        </el-form-item>
        <el-form-item label="加价比例：" prop="upScale">
          <el-input v-model="formData.upScale" maxlength="2" placeholder="请输入加价比例" @input="inputNumber($event, formData, 'upScale')">
            <template slot="append">%</template>
          </el-input>
        </el-form-item>
        <el-form-item label="加价上限：" prop="upLimit">
          <el-input v-model="formData.upLimit" maxlength="5" placeholder="请输入加价上限" @input="inputNumber($event, formData, 'upLimit')">
          </el-input>
        </el-form-item>
      </el-form>
      
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="visible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="confirm">确 定</el-button>
      </span>
    </el-dialog>
  </template>
  
  <script>
  import _api from "@/utils/request";
  import { inputNumber } from '@/utils/common'
  export default {
    name: "TimeQuoteRuleDia",
    props: {
      ruleList: {
        type: Array,
        default: () => []
      }
    },
    data() {
      const validateRange = (rule, value, callback) => {
        const { field } = rule
        const { priceMin, priceMax } = this.formData
        if (!priceMin || !priceMax) callback()
        if (Number(priceMin) >= Number(priceMax)) {
          if (field == 'priceMin') callback(new Error('起始值需小于结束值'))
          callback(new Error('结束值需大于起始值'))
        }
        callback()
      }
      const limitLenthVaild = (rule, value, callback) => {
        const number = Number(value)
        if (number < 0 || number >= 100) {
          callback(new Error('请输入小于100的数字'))
        }
        callback()
      }
      return {
        visible: false,
        loading: false,
  
        dialogType: '',
        formData: {
          priceMin: '',
          priceMax: '',
          upScale: '',
          upLimit: '',
        },
        rules: {
          priceMin: [
            { required: true, message: '请输入起始值', trigger: 'blur' },
            { validator: validateRange, trigger: 'blur' }
          ],
          priceMax: [
            { required: true, message: '请输入结束值', trigger: 'blur' },
            { validator: validateRange, trigger: 'blur' }
          ],
          upScale: [
            { required: true, message: '请输入加价比例', trigger: 'blur' },
            { validator: limitLenthVaild, trigger: 'blur' }
          ],
          upLimit: [
            { required: true, message: '请输入加价上限', trigger: 'blur' },
          ],
        }
      };
    },
    methods: {
        closeRuluer(){
            this.$refs['rulurform'].clearValidate();
        },
      open(row) {
        if (row) {
          this.dialogType = 'edit'
        } else {
          this.dialogType = 'add'
        }
        this.formData = row ? JSON.parse(JSON.stringify(row)) : {
          priceMin: '',
          priceMax: '',
          upScale: '',
          upLimit: '',
        }
        this.visible = true
      },
      inputNumber,
      confirm() {
        this.$refs['rulurform'].validate((vaild) => {
          if (vaild) {
            this.$emit('confirm', this.dialogType, this.formData)
            this.visible = false
          }
        })
      },
    }
  };
  </script>
  
  <style lang="scss" scoped>
  
  </style>